class UserInfoCreate
    constructor: (options) ->
        @.$el = null

        @.attrs = options?.attrs ? false
        @.badge = options?.badge ? false
        @.basicUser = options?.basicUser ? false
        @.joined = options?.joined ? 'n/a'
        @.joinedText = options?.joinedText ? 'Dabei seit'
        @.link = options?.link ? '#'
        @.messageLink = options?.messageLink ? false
        @.messageLinkText = options?.messageLinkText ? 'Private Nachricht'
        @.name = options?.name ? 'Nutzername'
        @.pic = options?.pic ? false
        @.posts = parseInt options?.posts, 10
        @.posts = if !isNaN(@.posts) then @.posts else 0
        @.postsLink = options?.postsLink ? '#'
        @.postsText = options?.postsText ? 'Beitrag'
        @.postsTextPlural = options?.postsTextPlural ? 'Beiträge'
        @.rank = options?.rank ? false
        @.smokeFree = parseInt options?.smokeFree, 10
        @.smokeFree = if !isNaN(@.smokeFree) then @.smokeFree else false
        @.smokeFreeText = options?.smokeFreeText ? 'rauchfrei seit'
        @.smokeFreeUnitText = options?.smokeFreeUnitText ? 'Tag'
        @.smokeFreeUnitTextPlural = options?.smokeFreeUnitTextPlural ? 'Tagen'
        @.onWhite = options?.onWhite ? false

        @.CreateElement()

        return @.$el

    CreateElement: ->
        @.$el = document.createElement 'div'
        @.$el.classList.add 'user-info'
        if @.attrs
            @.$el = window.appUtils.Attributes @.attrs, @.$el
        @.$el.appendChild new ProfilePicCreate {
            attrs: {
                class: ['user-info__pic']
            },
            badge: @.badge,
            onWhite: @.onWhite,
            pic: @.pic
        }
        @.$el.innerHTML += "
            #{ if @.basicUser then "<div class='user-info__name'>#{ @.name }</div>" else "<a href='#{ @.link }' class='user-info__name'>#{ @.name }</a>" }
            #{ if @.rank then "<b class='user-info__rank'>#{ @.rank }</b>" else "" }
            <div class='user-info__info'>
                <div class='user-info__joined'><b>#{ @.joinedText }:</b>#{ @.joined }</div>
                #{ if @.smokeFree then "<div class='user-info__smoke-free'><b>#{ @.smokeFreeText }:</b>#{ @.smokeFree } #{ if @.smokeFree > 1 || @.smokeFree < 1 then @.smokeFreeUnitTextPlural else @.smokeFreeUnitText }</div>" else "" }
            </div>
            #{ if !@.basicUser then "#{ if @.posts > 0 then "<a href='#{ @.postsLink }' class='user-info__posts icon-arrow-after'>" else "<div class='user-info__posts icon-arrow-after'>" }#{ @.posts } #{ if @.posts > 1 || @.posts < 1 then @.postsTextPlural else @.postsText }#{ if @.posts > 0 then "</a>" else "</div>" }" else "" }
            #{ if @.messageLink && !@.basicUser then "<a href='#{ @.messageLink }' class='user-info__message icon-arrow-after'>#{ @.messageLinkText }</a>" else "" }
        "
        return

window.CreateUserInfo = (options) ->
    return new UserInfoCreate options